<template>
  <div>
    <EvaluateHomeVisual />
    <EvaluateHomeMain />
  </div>
</template>

<script>
// Components
import EvaluateHomeMain from '~/components/EvaluateHomeMain.vue'
import EvaluateHomeVisual from '~/components/EvaluateHomeVisual.vue'

export default {
  components: { EvaluateHomeVisual, EvaluateHomeMain },
  async asyncData({ route, $axios }) {
    try {
      const metaRes = await $axios.get('/_api/api/v1/meta', {
        params: {
          slug: `/${route.name}`,
        },
      })
      const meta = metaRes.data.data
      return { meta }
    } catch (error) {
      return {
        meta: {
          title: 'Valuta casa in modo facile, veloce, sicuro',
          description:
            'Scopri quanto vale la tua casa con il Report gratuito Valore Casa',
        },
      }
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
